import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useGetEmailQuery } from "@/store/service";
import { ApplicationStep } from "@/enum/ApplicationStep";
import { useAuth } from "@/context/AuthContext";

const ApplicationContinue = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { isAuthenticated, refreshAuthStatus } = useAuth();
  const { data: emailData, isLoading, isSuccess, isError } = useGetEmailQuery(params.id!);

  useEffect(() => {
    if (isError || (isSuccess && !emailData)) {
      navigate(isAuthenticated ? "/dashboard" : "/login");
    }
  }, [isError, isSuccess, emailData]);

  useEffect(() => {
    const application = emailData?.application;
    if (isSuccess && application) {
      (async () => {
        await refreshAuthStatus();
        navigate(`/application/${application.id}/${application.step ?? ApplicationStep.User}`);
      })();
    }
  }, [isSuccess, emailData]);

  if (isLoading || !emailData) {
    return <>Loading application...</>;
  }

  return <></>;
};

ApplicationContinue.propTypes = {};

export default ApplicationContinue;
